/** 是否为 Vite 构建环境（npm 脚本名包含 vite） */
const isUseVite = /vite/i.test(process.env.npm_lifecycle_script || '')

/** 统一读取环境变量：Vite 走 import.meta.env，webpack 走 process.env */
const readEnv = (key: string): string | undefined => {
  if (isUseVite) {
    // @ts-expect-error import.meta.env 是 Vite 专属，webpack(CommonJS) 不支持
    const viteEnv = (import.meta as any).env
    if (viteEnv && viteEnv[key] !== undefined) {
      return viteEnv[key]
    }
  }
  return process.env?.[key]
}

/** 环境变量 */
const NODE_ENV = readEnv('NODE_ENV') || 'development'
/** 是否为生产环境 */
const isBuild = NODE_ENV === 'production'
/** 默认语言环境 */
const VUE_APP_DEFAULT_I18N = readEnv('VUE_APP_DEFAULT_I18N')
/** 请求域名 */
const VUE_APP_BASE_API = readEnv('VUE_APP_BASE_API')

/** 是否启用sentry */
const openSentry = readEnv('VUE_APP_SENTRY_SWITCH') === 'true'
/** sentry DSN */
const VUE_APP_SENTRY_DSN = readEnv('VUE_APP_SENTRY_DSN')
/** sentry token */
const VUE_APP_SENTRY_TOKEN = readEnv('VUE_APP_SENTRY_TOKEN')

export const env = {
  isUseVite,
  isBuild,
  NODE_ENV,
  VUE_APP_BASE_API,
  VUE_APP_DEFAULT_I18N,
  openSentry,
  VUE_APP_SENTRY_DSN,
  VUE_APP_SENTRY_TOKEN,
}